<template>
    <div class="fallback">
        <router-link class="back-button" :to="`/location/detail/${currentLocation.slug}`">
            <i class="fas fa-chevron-left"></i>
        </router-link>
        <div id="ARFallbackCanvas"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { sketch } from "@/assets/fallbackAR/sketch.js";

const P5 = require("p5");

export default {
    data() {
        return {
            p5: null,
            customURL: "kkllkj"
        };
    },
    mounted() {

        console.log( this.currentLocation );
        console.log( this.currentLocation.augmented_reality.fallback );

        setTimeout( () => {
            this.p5 = new P5(sketch);
            this.p5.customURL = this.url+this.currentLocation.augmented_reality.fallback;
        }, 150)
    },
    beforeDestroy() {
        this.p5.stop();
    },
    computed: {
        ...mapGetters(["sortedLocations", "lang"]),
        currentLocation() {
            let slug = this.$route.params.slug;
            let location = this.sortedLocations.find(obj => {
                return obj.slug == slug;
            });
            if (location == undefined) {
                console.log("Slug is not found!");
            }
            return location;
        },
        url(){
            return window.location.protocol+"//"+window.location.host;
        },
    },
    methods: {}
};
</script>

<style lang="scss" scoped >
#ARFallbackCanvas {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9998;
}

.back-button {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    align-items: center;
    text-align: center;
    width: 32px;
    height: 32px;

    .fas {
        width: 100%;
        font-size: 16px;
    }
}

body {
    /* overflow: hidden; */
}
</style>
